import React, {useState} from 'react';
import styled from 'styled-components';
import MotifIcon from '@ey/motif-react-wrapper/Icon';
import MotifAccordion from '@ey/motif-react-wrapper/Accordion';
import MotifAccordionContent from '@ey/motif-react-wrapper/AccordionContent';
import { contentIcAdd24px, contentIcRemove24px } from '@ey/motif-react-wrapper/assets/icons';
import PropTypes from 'prop-types';
import RowItems from './RowItems';

function GroupItem(props) {
	const {cellType, listData, groupHeaderLabel, className, groupConfig} = props;

	const [open, setOpen] = useState(false);

	const getCellTemplate = () => {
		let template = null;

		if (cellType == 'GroupCell' || cellType == 'GroupHeaderCell') {
			return getGroupItemTemplate(cellType);
		}

		return template;
	};

	const getGroupItemTemplate = (cellType) => {
		return (
			<StyledGroupedAccordionHeader title={groupHeaderLabel} className={`${cellType} accordion-title ellipsis`} onClick={() => setOpen(!open)}>
				<MotifIcon src={open ? contentIcRemove24px : contentIcAdd24px} />{groupHeaderLabel}
			</StyledGroupedAccordionHeader>
		);
	};

	return (
		// <StyledCellItemContainer className={`group-cell-wrap column-header ${className ? className : ''}`}>
			<StyledGroupedAccordion>
				<MotifAccordion open={open} onOpen={() => null} onClose={() => null}>
					{getCellTemplate()}
					<MotifAccordionContent>
						<RowItems
							groupName = {groupHeaderLabel}
							cellType={'GroupRows'} 
							groupConfig = {groupConfig} 
							listData = {listData}
							listRowItemClassName = {groupConfig.listRowItemClassName}
							>	
						</RowItems>
					</MotifAccordionContent>
				</MotifAccordion>
			</StyledGroupedAccordion>
		// </StyledCellItemContainer>
	);
}

GroupItem.propTypes = {
	cellType: PropTypes.string.isRequired
};

export default GroupItem;

const StyledCellItemContainer = styled.span``;

const StyledGroupedAccordion = styled.div`
	.motif-accordion {
		border: none;
		background: transparent;
		background-color: transparent !important;
		cursor: pointer;
	}
	.motif-accordion-content {
		padding: 0;
		line-height: 2.4rem;
	}
	.accordion-title.GroupHeaderCell {
		position: relative;
    	padding-left: 2.5rem;
		.motif-icon {
			position: absolute;
    		left: -0.5rem;
			top: -1px;
		}
	}
`;

const StyledGroupedAccordionHeader = styled.span`
	&.ellipsis.GroupHeaderCell {
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
		white-space: break-spaces;
	}
`;
